import Util from './Util.js';

class TopButton {
    constructor() {
        this.topButton = $('.footer-top');
        this.addEvents();
    }

    toggleTopButton(_e){
        const scrollTop = $(window).scrollTop();
        const baseOffsetY = $(window).height() /2;

        if(scrollTop > baseOffsetY){
            this.topButton.addClass('is-active');
        }else{
            this.topButton.removeClass('is-active');
        }
    }

    addEvents(){
        $(window).on('scroll', (_e) => {this.toggleTopButton(_e)});
    }
} // end of class
export default TopButton;
